import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import CelebrationIcon from "@mui/icons-material/Celebration";
import BugReportIcon from "@mui/icons-material/BugReport";

export default function ReleaseNotesDialog() {
  const [open, setOpen] = useState(false);
  const STORAGE_KEY = "update_20.10.2026";

  useEffect(() => {
    const hasSeenNotes = localStorage.getItem(STORAGE_KEY);
    // If the key doesn't exist or isn't "true", show the dialog
    if (hasSeenNotes !== "true") {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose} // user can click outside to close, which also sets localStorage
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
        },
      }}>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <CelebrationIcon color="primary" fontSize="large" />
        <Typography variant="h5" fontWeight="bold">
          Обновление MedLog: Что нового?
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" paragraph color="text.secondary">
            20.10.2026
          </Typography>

          <Typography variant="h6" gutterBottom color="primary.main">
            🌟 Ключевые изменения и новые возможности:
          </Typography>

          <Typography component="div" variant="body1" sx={{ mb: 2 }}>
            <ul style={{ paddingLeft: "20px", marginTop: 0 }}>
              <li style={{ marginBottom: "10px" }}>
                <strong>Выбор периода в статистике дашборда:</strong> На главной панели
                аналитики администратора добавлены быстрые фильтры («Сегодня», «7 дней»,
                «30 дней», «Год», «Все время») и выбор произвольного интервала дат («Период с / по»).
                Все графики, показатели и сводки мгновенно пересчитываются под выбранный диапазон.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <strong>Интерактивные таблицы статистики с сортировкой и фильтрами:</strong> В
                таблицах географии (города отправления, назначения, маршруты) и аналитики
                логистов включены сортировка по любому столбцу, фильтрация данных, встроенный поиск
                и экспорт.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <strong>Уточнение расчета сдвоенных заказов:</strong> Заказы одной и той же
                компании в один день из одного города забора больше не считаются сдвоенными
                между собой (только одна заявка компании в день участвует в группировке),
                за исключением компании «Частные лица» (ID 87).
              </li>
              <li style={{ marginBottom: "10px" }}>
                <strong>Автоматическое создание пациентов из PDF:</strong> Если при распознавании
                PDF-бланка анализа пациент еще не найден в базе, система автоматически создает
                новую карточку пациента по распознанным ФИО, дате рождения, полу и региону.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <strong>Прикрепление деталей анализов к пациенту:</strong> Результаты, даты,
                наименования тестов, анамнез и ссылки на обработанные PDF-файлы теперь автоматически
                сохраняются в историю анализов пациента в базе.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <strong>Исправление просмотра и скачивания PDF:</strong> Устранена ошибка
                авторизации (Missing Authorization Header) при открытии и скачивании оригиналов
                распознанных PDF-бланков.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <strong>Сохранение и обновление адресов докторами:</strong> Исправлена ошибка,
                мешавшая врачам и клиникам сохранять новые адреса забора/доставки в адресную
                книгу при создании заказов.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <strong>Синхронизация PDF с базой пациентов и заказами:</strong> Добавлена
                кнопка в панели PDF и скрипт для пакетной синхронизации ранее загруженных файлов:
                автоматическое создание пациентов с автоподстановкой столиц/центров регионов
                (Уфа для Башкортостана, Владивосток для Приморского края и др.), сохранение
                истории анализов с файлами и привязка пациентов к заказам.
              </li>
            </ul>
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 1.5,
              backgroundColor: "background.default",
              p: 2,
              borderRadius: 2,
            }}>
            <BugReportIcon color="warning" />
            <Typography variant="body2" color="text.secondary">
              Если в процессе работы вы столкнулись с какой-либо ошибкой или
              проблемой, пожалуйста,{" "}
              <strong>напишите в чате (сообщениях) разработчику</strong>. Мы
              оперативно все проверим и исправим!
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ pb: 2, pr: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
          size="large"
          sx={{ borderRadius: 2, px: 4 }}>
          Ознакомлен(а)
        </Button>
      </DialogActions>
    </Dialog>
  );
}
